import Tabs, { TabsProps } from "components/basic/tabs";
import { useState } from "react";
import TeamTable from "./teamTable";

export interface TeamData {
  name: string;
  email: string;
  joinedAt: string;
  access: string;
}

const Team = () => {
  const [selectedTab, setSelectedTab] = useState("users");

  const tabData: TabsProps = {
    selectedTab: selectedTab,
    setSelectedTab: setSelectedTab,
    tabs: [{ label: "Users", path: "users" }],
    align: "left",
  };

  const data: TeamData[] = [
    {
      name: "Jordan Claramari",
      email: "calamarijordan@echohive.com",
      joinedAt: "2025-05-01T00:00:00Z",
      access: "Full Access",
    },
    {
      name: "Bashir Ramasul",
      email: "bashirmarasul@echohive.com",
      joinedAt: "2025-05-01T00:00:00Z",
      access: "Leads Only",
    },
    {
      name: "Sarah Wilson",
      email: "s.wilson2200@echohive.com",
      joinedAt: "2025-05-01T00:00:00Z",
      access: "Leads Only",
    },
    {
      name: "Albert Nerdo",
      email: "hansdontdanse@echohive.com",
      joinedAt: "2025-05-01T00:00:00Z",
      access: "Admin",
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Tabs {...tabData} />
      <div>
        {(() => {
          switch (selectedTab) {
            case "users":
              //   return <MessageList messages={messages} />;
              return <TeamTable data={data} />;
            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
};

export default Team;
